import _ from 'lodash';
import template from './equipmentManagement.modal.html';

/* @ngInject */
function EquipmentManagementModalController(
  $uibModalInstance,
  currentRcu,
  equipment,
  appConfig
) {
  const vm = this;
  let oldType;
  vm.$onInit = init;
  vm.equipmentType = null;
  vm.equipmentModalTitle = 'Add Equipment';
  vm.newEquipment = {};

  vm.type = equipment.equipmentType || null;
  // collapses each property's .description so the format fits what utilDropdown is expecting
  vm.prettyTypeConstant = _.mapValues(appConfig.equipmentTypes, type => type.description);
  vm.changeChild = changeChild;
  vm.close = close;
  vm.dismiss = dismiss;
  vm.isValidJSON = isValidJSON;

  function init() {
    vm.currentRcuId = currentRcu.id;

    if (equipment) {
      vm.equipmentModalTitle = 'Edit Equipment';
      vm.currentType = equipment.equipmentType;
      vm.newEquipment = angular.copy(equipment);
      vm.editing = true;
    } else {
      const defaults = {
        // Name - Site - ID is a popular unofficial convention
        name: `${currentRcu.name.split('-').slice(0, 2).join('-')} - `,
        rcu: vm.currentRcuId,
        org: currentRcu.org,
        groups: _.cloneDeep(currentRcu.groups),
      };
      Object.assign(vm.newEquipment, defaults);
      vm.editing = false;
    }
  }

  function changeChild() {
    const newType = vm.newEquipment.equipmentType;
    if (!vm.type) {
      vm.type = newType;
    }
    if ((newType === 'tripwires' && oldType !== 'tripwires') ||
    (oldType === 'tripwires' && newType !== 'tripwires')) {
      vm.type = vm.newEquipment.equipmentType;
      angular.copy({
        rcu: vm.currentRcuId,
        equipmentType: vm.type
      }, vm.newEquipment);
    } else if (oldType === 'cameras') {
      _.unset(vm.newEquipment, 'settings.cameraRegion');
    }
    oldType = newType;
  }

  async function close(eq) {
    return $uibModalInstance.close(eq);
  }

  function dismiss() {
    $uibModalInstance.dismiss('closed');
  }

  function isValidJSON(str) {
    try {
      angular.fromJson(str);
      angular.toJson(str);
      return true;
    } catch {
      return false;
    }
  }
}

export default {
  template,
  controller: EquipmentManagementModalController,
  controllerAs: 'eqManModal'
};
